import { Renderer } from 'amis';
import { RendererProps } from 'amis';
import React from 'react';
import AIHmiLayout from './components/layout/AIHmiLayout';

export interface AIHmiPluginProps extends RendererProps {
  target?: string;
}

const AIHmi: React.FC<AIHmiPluginProps> = ({
  businessId,
  aiCapabilityCode,
}) => {
  return (
    <AIHmiLayout 
      businessType={aiCapabilityCode}
      businessId={businessId}
      defaultCapabilityCode={aiCapabilityCode}
    />
  )
};

@Renderer({
  test: /\bagimx-ai-hmi$/,
  name: 'agimx-ai-hmi',
})
export default class AIHmiPlugin extends React.Component<AIHmiPluginProps> {
  render() {
    return (
        <div style={{ height: this.props.height || '90vh' }}>
            <AIHmi {...this.props} />
        </div>
    );
  }
}